module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/5/2-c74e42ca0142c4d40610f148b7ef58b2.jpg";